import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const QuoteVersionInput = () => {
  const { versionId = '' } = useParams();
  const decodedId = versionId ? atob(versionId) : versionId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'quoteVersion';

  useEffect(() => {
    if (versionId) { setIsEditing(true); fetchDetails(); }
  }, [versionId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['quoteVersion'] + id + '/', { headers });
      setFormData(response.data);
    } catch (error) { console.error('Error fetching Quote Version details:', error); }
  };

  const fields = [{"name":"quote","label":"Quote","type":"number"},{"name":"version_number","label":"Version Number","type":"number"},{"name":"notes","label":"Notes","type":"textarea"}];

  return (
    <div>
      <h1>{isEditing ? 'Edit Quote Version' : 'Create Quote Version'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default QuoteVersionInput;
